import Vue from "vue";
import Vuex from "vuex";

import user from "./user.js";
import creative from "./creative.js";
import creativeFolder from "./creativeFolder.js";
import audience from "./audience.js";
import report from "./report.js";
import asset from "./asset.js";
import advertiser from "./advertiser.js";
import userManagement from "./userManagement.js";
import creator from "./creator.js";
import creatorManagement from "./creatorManagement.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    stageType: "front", //front or back
    isSidebarCollapse: true,
    isDialogVisible: false,
    isContextMenuVisible: false,
    dialogConf: {
      type: "",
      row: {},
    },
    contextMenuConf: {
      type: "",
      row: {},
    },
  },
  getters: {
    getSidebarCollapse: (state) => state.isSidebarCollapse,
    getDialogVisible: (state) => state.isDialogVisible,
    getContextMenuVisible: (state) => state.isContextMenuVisible,
  },
  mutations: {
    setSidebarCollapse: (state, data) => {
      state.isSidebarCollapse = data;
    },
    setDialogVisible: (state, data) => {
      state.isDialogVisible = data;
    },
    setContextMenuVisible: (state, data) => {
      state.isContextMenuVisible = data;
    },
    setDialogConf: (state, data) => {
      state.dialogConf = data;
    },
    setContextMenuConf: (state, data) => {
      state.contextMenuConf = data;
    },
    setStageTypeToBackstage: (state) => {
      state.stageType = "back";
    },
  },
  actions: {
    init({ commit }) {
      commit("advertiser/setAdvertisers", []);
      commit("asset/setAssets", []);
      commit("audience/setAudiences", []);
      commit("creative/setCreatives", []);
      commit("creativeFolder/setCreativeFolders", []);
      commit("user/setUserInfo", {});
      commit("userManagement/setUserList", []);
    },
    showContextMenu({ commit, state }, data) {
      commit("setContextMenuConf", data);
      commit("setContextMenuVisible", true);
    },
    showDialog({ commit, state }, data) {
      commit("setDialogConf", data);
      commit("setDialogVisible", true);
    },
  },
  modules: {
    user,
    creative,
    creativeFolder,
    audience,
    report,
    asset,
    advertiser,
    userManagement,
    creator,
    creatorManagement,
  },
});
